import api from "./axios";

export function syncStoresFromOSM({ lat, lon, radius_km = 8 }) {
  return api.post("/stores/osm/sync", null, { params: { lat, lon, radius_km } });
}

export function getNearbyStores(params) {
  return api.get("/stores/nearby", { params });
}
